<template>
  <div v-if="getIsConfigurable">
    <p
      class="product_configure_text"
      :id="deviceType + '-configure_text'"
      v-html="getProductConfigureMessage"
    ></p>

    <BaseButton
      @onClick="ToolRedirect"
      class="configure__button"
      :buttonid="deviceType + '-configure_now'"
      isPrimary="true"
    >
      <i class="material-icons" materialid="build_configure">build</i>
      {{ getConfigureButtonText }}
    </BaseButton>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BaseButton from "../base/BaseButton";

export default {
  props: {
    deviceType: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters("product", [
      "getProductConfigureMessage",
      "getIsConfigurable",
      "getConfigureButtonText",
      "getToolUrl"
    ])
  },
  components: {
    BaseButton
  },

  methods: {
    ToolRedirect() {
      const toolUrl = this.getToolUrl;
      if (toolUrl) {
        let sitecorePreviousURL = window.$cookies.get("sitecorePreviousURL");
        if (sitecorePreviousURL) {
          window.$cookies.set("sitecorePreviousURL", toolUrl);
        } else {
          window.$cookies.set(
            "sitecorePreviousURL",
            toolUrl,
            null,
            null,
            "legrandav.com"
          );
        }
        window.open(toolUrl, "_blank");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.product_configure_text {
  text-align: center;
  margin-bottom: 7px;
  padding-top: 29px;
  border-top: 3px solid #e5e5e5;
  &::v-deep p strong span {
    font-family: $font-family-sans-serif-medium;
    letter-spacing: 0.25px;
    font-size: 20px !important;
  }
  &::v-deep p {
    font-family: $font-family-sans-serif-regular;
    letter-spacing: 0.25px;
    font-size: 16px;
    margin-bottom: 1px;
  }
  @include media-breakpoint-up(md) {
    padding-top: 12px;
    margin-bottom: 2px;
    border-top: none;
  }

  @include media-breakpoint-up(lg) {
    padding-top: 22px;
    &::v-deep p strong span {
      font-size: 24px !important;
    }
  }
}
.configure__button {
  text-transform: none;
  width: 100%;
  background-color: $aqua;
  border-color: $aqua;
  color: $white;
  font-family: $font-family-sans-serif-bold;
  font-size: 16px;
  font-weight: normal;
  height: 45px;
  letter-spacing: 0px;
  margin-bottom: 25px;
  padding: 0 0 1px 0;

  @include media-breakpoint-up(md) {
    width: 88%;
    margin-left: 20px;
    margin-bottom: 0;
    margin-top: 7px;
  }
  @include media-breakpoint-up(lg) {
    width: 90%;
    margin-left: 20px;
  }

  i {
    font-size: 18px;
    margin: 0px 10px 0px 0px;
  }
}
</style>
